import React, { useState } from 'react';
import { Paper, Stack, Title, Space, Center } from '@mantine/core';
import Header from '~src/components/Header';
import { useNavigate } from 'react-router-dom';
import JoinGroup from '~src/components/JoinGroup';
import CreateGroup from '~src/components/CreateGroup';

export default function Onboarding() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100dvh',
        width: '100%',
        overflow: 'hidden',
      }}
    >
      <Header pageName="Onboarding" />
      <div
        style={{
          flex: 1,
          overflowY: 'scroll',
          width: '100%',
          paddingTop: 'var(--mantine-spacing-lg)',
        }}
      >
        <Center style={{ margin: '0 5%', paddingBottom: '2rem' }}>
          <Stack
            align="stretch"
            justify="flex-start"
            gap="lg"
            style={{ width: '100%', maxWidth: 'var(--global-content-width)' }}
          >
            <Title ta="center" order={1}>
              You have no groups yet. Let's fix that!
            </Title>
            <Paper shadow="md" radius="md" p="xl">
              <CreateGroup />
            </Paper>
            <Paper shadow="md" radius="md" p="xl">
              <JoinGroup />
            </Paper>
          </Stack>
        </Center>
      </div>
    </div>
  );
}
